var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.getSpinner)?_c('div',{staticClass:"page"},[_c('b-spinner',{key:'primary',staticClass:"spinner",attrs:{"variant":'primary'}})],1):_vm._e(),_c('div',{attrs:{"id":"nav"}},[_c('TopHeader')],1),_c('router-view',{staticStyle:{"padding-top":"50px"}}),_c('div',{attrs:{"id":"footer"}},[_c('BottomFooter')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }